const global = window;

// Toggle
inputs.behavior.toggle = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.toggle) {
        let toggle = data.toggle;
        if (typeof toggle === 'string') {
            try {
                toggle = JSON.parse(toggle);
            } catch (e) {
                toggle = { url: toggle };
            }
        }

        // Clé de synchronisation entre éléments liés
        if (toggle.key) {
            input.attr('data-toggle-key', toggle.key);
        }

        const activeClass = toggle.activeClass || data.activeClass || 'active';

        // Initialisation de l'état actif initial si spécifié
        let isActive = null;
        if (toggle.active !== undefined) {
            isActive = !!toggle.active;
        } else if (data.value !== undefined && data.value !== null) {
            isActive = !!data.value;
        }

        if (isActive !== null) {
            if (!input.attr('data-active')) {
                input.attr('data-active', isActive ? '1' : '0');
                if (isActive) {
                    input.addClass(activeClass);
                } else {
                    input.removeClass(activeClass);
                }
            }
            if (!isActive && !toggle.inactiveColor) {
                input.css('color', '');
            }
        }

        input.data('registered-toggle', true);
        input.click(function (event) {
            if (input.is(':disabled') || input.hasClass('btn--disabled') || input.attr('disabled') || input.data('hold')) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
            return global.toggleElement(this, toggle, event, inputWindow || parent);
        });
    }
    return data;
};

// Bascule générique d'un élément ou bouton d'action
global.toggleElement = function (element, toggleConfig, event, context) {
    const $el = $(element);
    let toggle = toggleConfig;
    if (!toggle) {
        const inputData = $el.data('data');
        toggle = (inputData && inputData.toggle) ? inputData.toggle : $el.data('toggle');
    }
    if (typeof toggle === 'string') {
        try {
            toggle = JSON.parse(toggle);
        } catch (e) {
            toggle = { url: toggle };
        }
    }
    if (!toggle) return false;

    if ($el.is(':disabled') || $el.hasClass('btn--disabled') || $el.attr('disabled') || $el.data('hold')) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        return false;
    }

    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }

    const inputData = $el.data('data') || {};
    const activeClass = toggle.activeClass || inputData.activeClass || 'active';
    const currentlyActive = $el.hasClass(activeClass) || $el.attr('data-active') == '1';
    const nextState = !currentlyActive;

    // Clé de synchronisation entre éléments liés
    const toggleKey = toggle.key || $el.attr('data-toggle-key');
    let $syncElements = $el;
    if (toggleKey) {
        $syncElements = $('[data-toggle-key="' + toggleKey + '"]').add($el);
    }

    const applyState = function ($elements, isActive) {
        $elements.each(function () {
            const $item = $(this);
            $item.attr('data-active', isActive ? '1' : '0');

            if (isActive) {
                $item.addClass(activeClass);
            } else {
                $item.removeClass(activeClass);
            }

            // Normalisation des propriétés de toggle
            const activeTip = toggle.activeTip || toggle.tip;
            const inactiveTip = toggle.inactiveTip || $item.data('initial-tip');
            const activeColor = toggle.activeColor || toggle.color;
            const inactiveColor = toggle.inactiveColor || $item.data('initial-color');
            const activeIcon = toggle.activeIcon || toggle.icon;
            const inactiveIcon = toggle.inactiveIcon || $item.data('initial-icon');

            // Mémoriser l'infobulle initiale si non enregistrée
            if ($item.data('initial-tip') === undefined) {
                const initTip = $item.data('tip-title') || $item.attr('title') || '';
                $item.data('initial-tip', initTip);
            }

            // Titre actif / inactif avec mise à jour immédiate du tooltip
            const targetTip = isActive ? activeTip : inactiveTip;
            if (targetTip !== undefined && targetTip !== null && targetTip !== '') {
                if (typeof global.updateTooltip === 'function') {
                    global.updateTooltip($item, targetTip);
                } else {
                    $item.attr('data-tip-title', targetTip);
                    $item.data('tip-title', targetTip);
                    if ($item.hasClass('protip')) {
                        $item.removeAttr('title');
                    } else {
                        $item.attr('title', targetTip);
                    }
                    const $tooltip = $('.protip-containers .protip-container');
                    if ($item.hasClass('tooltiped') && $tooltip.length) {
                        $tooltip.find('.protip-content').html(targetTip);
                    }
                }
            }

            // Couleur active / inactive
            // S'il n'y a pas de couleur sans le toggle (inactiveColor non défini), la couleur doit être supprimée quand on le met inactif
            if (isActive) {
                if (activeColor) {
                    $item.css('color', activeColor);
                    $item.find('.icon, [class*="icon-"], [class*="fa-"]').css('color', activeColor);
                }
            } else {
                if (inactiveColor) {
                    $item.css('color', inactiveColor);
                    $item.find('.icon, [class*="icon-"], [class*="fa-"]').css('color', inactiveColor);
                    if (activeColor) {
                        $item.removeClass('btn--' + activeColor);
                    }
                } else {
                    $item.css('color', '');
                    $item.find('.icon, [class*="icon-"], [class*="fa-"]').css('color', '');
                    $item.removeClass('icon--bg icon--dark');
                }
            }

            // Icône active / inactive
            if (activeIcon && inactiveIcon) {
                const targetIcon = isActive ? activeIcon : inactiveIcon;
                const otherIcon = isActive ? inactiveIcon : activeIcon;

                if ($item.attr('data-ico')) {
                    $item.attr('data-ico', targetIcon);
                }

                $item.find('.icon, [class*="icon-"], [class*="fa-"]').each(function () {
                    const $ico = $(this);
                    $ico.removeClass('icon-' + otherIcon).removeClass('fa-' + otherIcon);
                    $ico.addClass('icon-' + targetIcon);
                    if ($ico.attr('data-ico')) {
                        $ico.attr('data-ico', targetIcon);
                    }
                });
            }
        });
    };

    // Mise à jour visuelle optimiste immédiate
    applyState($syncElements, nextState);

    // Si retiré depuis le tableau des favoris, masquer la ligne immédiatement
    let $targetRow = null;
    if (!nextState && toggle.removeRow) {
        if (typeof toggle.removeRow === 'string') {
            if ($el.closest(toggle.removeRow).length) {
                $targetRow = $el.closest('tr');
            }
        } else if (toggle.removeRow === true) {
            $targetRow = $el.closest('tr');
        }
        if ($targetRow && $targetRow.length) {
            $targetRow.fadeOut(250);
        }
    }

    const url = toggle.url;
    if (!url) {
        $el.trigger('toggle:change', [nextState]);
        return true;
    }

    const method = (toggle.method || 'POST').toUpperCase();
    const requestData = toggle.data && typeof toggle.data === 'object' ? Object.assign({}, toggle.data) : {};

    const handleSuccess = function (response) {
        let res = response;
        if (typeof res === 'string') {
            try {
                res = JSON.parse(res);
            } catch (e) {}
        }

        let serverState = nextState;
        if (res && res.active !== undefined) {
            serverState = !!res.active;
        } else if (res && res.is_favorite !== undefined) {
            serverState = !!res.is_favorite;
        } else if (res && res.state !== undefined) {
            serverState = !!res.state;
        } else if (res && res.success === false) {
            // Rétablir l'état initial en cas d'erreur logique
            applyState($syncElements, currentlyActive);
            if ($targetRow && $targetRow.length) {
                $targetRow.show();
            }
            return;
        }

        applyState($syncElements, serverState);

        // Gestion de la ligne masquée / supprimée
        if (!serverState && $targetRow && $targetRow.length) {
            $targetRow.remove();
        } else if (serverState && $targetRow && $targetRow.length) {
            $targetRow.show();
        }

        // Rafraîchissement des cibles configurées
        const refreshConfig = toggle.refresh || (inputData && inputData.refresh) || $el.data('refresh');
        if (refreshConfig) {
            if (typeof global.refreshTargets === 'function') {
                global.refreshTargets(refreshConfig, $el);
            } else if (typeof inputReloadParent === 'function') {
                inputReloadParent($el);
            }
        }

        $el.trigger('toggle:success', [serverState, res]);
        $syncElements.trigger('toggle:synced', [serverState, res]);
    };

    const handleError = function (xhr, status, error) {
        applyState($syncElements, currentlyActive);
        if ($targetRow && $targetRow.length) {
            $targetRow.show();
        }
        $el.trigger('toggle:error', [error]);
    };

    if (typeof callAPI === 'function') {
        callAPI(method, url, requestData, handleSuccess, handleError);
    } else if (typeof $ !== 'undefined' && $.ajax) {
        $.ajax({
            url: url,
            type: method,
            method: method,
            data: requestData,
            dataType: 'json',
            success: handleSuccess,
            error: handleError
        });
    }

    return true;
};

// Delegated click handler de secours pour d'éventuels éléments statiques [data-toggle]
$(document).on('click', '[data-toggle]', function (event) {
    const $el = $(this);
    if ($el.data('registered-toggle') || $el.data('registered')) {
        return;
    }
    if ($el.is(':disabled') || $el.hasClass('btn--disabled') || $el.attr('disabled') || $el.data('hold')) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    }
    return global.toggleElement(this, null, event);
});
